import React from "react"
import { useContext } from 'react';
import { ContactContext } from './provider';

export function useContact() {
    const context = useContext(ContactContext)

    if (!context) throw new Error('useContact must be used within a ContactProvider')

    return context
}
